import styled from "styled-components";

export const Container = styled.div `

    display: none;

    &.showModal {
        position: absolute;
        top: 50px;
        right: 20px;
        padding-top: 20px;
        display: flex;
        z-index: 1;
    }

    @media(max-width: 800px) {

        &.showModal {
            top: 45px;
        }

    }
`

export const Content = styled.menu `

    display: flex;
    flex-direction: column;
    border-radius: 5px;
    background: #252525;
    box-shadow: 5px 5px 30px #000;
    padding: 10px;
    max-height: 350px;
    overflow-y: auto;

    a {
        display: flex;
        align-items: center;
        padding: 8px 12px;
        font-size: .8rem;
        color: #909090;
        font-weight: bold;
        text-transform: uppercase;
        text-decoration: none;
        margin: 5px 0;
        border-radius: 50px;
        transition: all .3s ease;
    }
    
    a:hover {
        color: #fff;
    }

    a img {
        width: 25px;
        border-radius: 5px;
    }

    a img, a i {
        margin-right: 10px;
    }
`